import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'
import styles from './Downloading.module.scss'

export const Downloading = () => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('main.downloading'))
    setBtns([{ text: t('buttons.cancel'), onClick: onClose, variant: 'cancel' }])
  }, [])

  return (
    <div className={styles['container']}>
      <span> {t('main.downloading')}</span>
      <span>{t('admin.electorsList.downloading')}</span>
    </div>
  )
}
